import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";

export default function QRDownload({ className, value, filename}) {
    const qrRef = useRef();

    const downloadQR = () => {
        const canvas = qrRef.current.querySelector("canvas");
        const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");

        const downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = filename ? `${filename}-${Date.now()}.png` : `qrcode-${Date.now()}.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    return (
        <div style={{width: "100%"}}>
            <div ref={qrRef} style={{display: "none"}}>
                <QRCodeCanvas
                    value={value}
                    size={512}
                    bgColor="#ffffff"
                    fgColor="#041E42"
                    level="H"
                />
            </div>

            <button style={{marginTop: 0}} className={className} onClick={downloadQR}>
                Download QR Code
            </button>
        </div>
    );
}